const baseStyle = {
  backgroundColor: `gray.75`,
  border: `2px solid`,
  borderColor: `gray.75`,
  color: `heading`,
  cursor: `pointer`,
  fontSize: `md`,
  fontWeight: `semibold`,
  height: `auto`,
  p: 4,
};

const variants = {
  withIcon: {
    pl: 16,
  },
  proRikApp: {
    backgroundColor: `inherit`,
    borderColor: "inherit",
    border: "1px solid",
    fontSize: "md",
    height: "40px",
    fontWeight: "medium",
    p: ".5rem 1rem",
    _placeholder: {
      color: `red.100`,
    },
  },
};

export const Select = {
  baseStyle,
  variants,
};
